import { EventGroup } from '@qodana/tracking'

import type { CloudTrackingContext } from '../context'
import { withPage, Page } from '../pages'

type PageOpenEventData = {
	page: Page
}

/**
 * https://youtrack.jetbrains.com/issue/FUS-1698/Add-new-group-cloud-pages
 */
export const PageEventGroup = new (class extends EventGroup<
	CloudTrackingContext,
	PageOpenEventData | {}
> {
	groupId = 'cloud.pages' as const
	groupVersion = 7 as const // https://youtrack.jetbrains.com/issue/FUS-2210/Update-group-cloud.pages

	decorators = [withPage]

	events = {
		open: this.addEvent('open'),
		restore: this.addEvent('restore'),
		errorAlert: this.addEvent('errorAlert'),
		paginate: this.addEvent<{ pageNumber: number; pageSize: number }>('paginate'),
	}
})()
